export namespace QuoteConstant {
  export const REFRESH_INTERVAL = 900000; // NOTE: 15 minutes
}
